// Utilities
import { authComputed } from 'Store/helpers'

export default {
  computed: {
    ...authComputed,
    isEmployee() {
      return this.userType === 'EMPLOYEE'
    },
  },
}
